import { render, staticRenderFns } from "./workDetails.vue?vue&type=template&id=22110c50"
import script from "./workDetails.vue?vue&type=script&lang=js"
export * from "./workDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports